import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { LeaveBalance, LeaveBalanceCreate, LeaveBalanceFilter } from '../data/leaveBalance';

export function createLeaveBalanceService(client: AxiosInstance) {
  return createCrudService<LeaveBalance, LeaveBalanceCreate, LeaveBalanceFilter>(
    client,
    '/hrm/LeaveBalance',
    'id',
  );
}

export type LeaveBalanceService = CrudService<LeaveBalance, LeaveBalanceCreate, LeaveBalanceFilter>;
